export default {
  AutocompleteStations__CLOSE_ARIA_LABEL: "Select to close",
};
